import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import { CondensedTable } from '@elementary/common-ui/components/Table';

const Wrapper = styled(FlexColumn)<{ $maxHeight?: number }>`
  min-height: 0;
  ${({ $maxHeight }) =>
    $maxHeight != null &&
    `
    max-height: ${$maxHeight}px;
    overflow: auto;
  `}

  th,
  td {
    font-family: monospace;
  }
`;

type Column = {
  id: string;
  display_name: string;
  type?: string;
};

type SampleCellValue = string | number | boolean | object;

type Props = {
  data: Array<Record<string, unknown>>;
  columns?: Column[];
  padding?: string;
  hideBorder?: boolean;
  maxHeight?: number;
};

const toSampleCellValue = (value: unknown): SampleCellValue => {
  if (value == null) {
    return '';
  }
  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'object'
  ) {
    return value;
  }
  return String(value);
};

const toSampleRows = (
  data: Array<Record<string, unknown>>,
): Array<Record<string, SampleCellValue>> =>
  data.map((row) =>
    Object.fromEntries(
      Object.entries(row).map(([key, value]) => [
        key,
        toSampleCellValue(value),
      ]),
    ),
  );

const SamplesTable = ({
  data,
  columns,
  padding = '0',
  hideBorder,
  maxHeight,
}: Props) => (
  <Wrapper $maxHeight={maxHeight}>
    <CondensedTable
      data={toSampleRows(data)}
      columns={columns}
      padding={padding}
      hideBorder={hideBorder}
    />
  </Wrapper>
);

export default SamplesTable;
